/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputWeatherCoverage
 */
export interface OutputWeatherCoverage {
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherCoverage
     */
    avgWindAgeSec?: number;
    /**
     * MissionsAirborne — заявки в повітрі; MissionsWithWind — скільки з них мають вектор вітру.
     * @type {number}
     * @memberof OutputWeatherCoverage
     */
    missionsAirborne?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherCoverage
     */
    missionsWithWind?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherCoverage
     */
    samples?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputWeatherCoverage
     */
    validFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputWeatherCoverage
     */
    validTo?: string;
}

/**
 * Check if a given object implements the OutputWeatherCoverage interface.
 */
export function instanceOfOutputWeatherCoverage(value: object): boolean {
    return true;
}

export function OutputWeatherCoverageFromJSON(json: any): OutputWeatherCoverage {
    return OutputWeatherCoverageFromJSONTyped(json, false);
}

export function OutputWeatherCoverageFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputWeatherCoverage {
    if (json == null) {
        return json;
    }
    return {
        
        'avgWindAgeSec': json['avgWindAgeSec'] == null ? undefined : json['avgWindAgeSec'],
        'missionsAirborne': json['missionsAirborne'] == null ? undefined : json['missionsAirborne'],
        'missionsWithWind': json['missionsWithWind'] == null ? undefined : json['missionsWithWind'],
        'samples': json['samples'] == null ? undefined : json['samples'],
        'validFrom': json['validFrom'] == null ? undefined : json['validFrom'],
        'validTo': json['validTo'] == null ? undefined : json['validTo'],
    };
}

export function OutputWeatherCoverageToJSON(value?: OutputWeatherCoverage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'avgWindAgeSec': value['avgWindAgeSec'],
        'missionsAirborne': value['missionsAirborne'],
        'missionsWithWind': value['missionsWithWind'],
        'samples': value['samples'],
        'validFrom': value['validFrom'],
        'validTo': value['validTo'],
    };
}

